import React, { useState, useEffect } from 'react';
import { Routes, Route, Link, useParams, useLocation, Navigate  } from 'react-router';
import Request from '../Request/Request'
import Store from '../Store/Store'
import Page from '../Page/Page'
import SignIn from '../Admin/SignIn'
import Admin from '../Admin/Admin'
import AdminPages from '../AdminCruises/AdminPages'
import AdminCruises from '../AdminCruises/AdminCruises'
import AdminBookings from '../AdminCruises/AdminBookings'
import { refreshGalleries } from '../App/refreshContent'

function NoMatch( props ) {
  return (
    <div>NoMatch</div>
  )
}

function updateStore( getApiCall, setState ) {
  Request.get( getApiCall, result => { 
    Store.set( getApiCall, result.data )
    setState( result.data ) 
  } )
}

export default function App() {

  const location = useLocation()
  //console.log( location.pathname )
  const [ tmp, setTmp ] = useState( 1  )
  const [ pages, setPages ] = useState( Store.get( 'pages' ) || []  )
  const [ content, setContent ] = useState( Store.get( 'content' ) || {} )
  const [ categories, setCategories ] = useState( Store.get( 'categories' ) || {} )
  const [ cruises, setCruises ] = useState( Store.get( 'cruises' ) || {} )

  const updateContent = () => {
    //refreshGalleries()
    updateStore( 'pages', setPages )
    updateStore( 'content', setContent )
    updateStore( 'categories', setCategories )
    updateStore( 'cruises', setCruises )
  }

  const commonProps = { content, cruises, categories }
  const adminProps = { updateContent }

  const elements = {
    FrontPage:<Page pageId="7ce8300f-5fd2-478e-93f9-2ad17abb6eca"  { ...commonProps } />,
    Cruise:<Page pageId="b1a46ad4-18d0-413f-be1a-751582b14d62" { ...commonProps } />,
    Cabins:<Page pageId="d6e64aca-5745-4034-b0fb-fc291bdaa61f" { ...commonProps } />,
    Stay:<Page pageId="c399e1f8-5238-47d5-8e51-2c6162ed9cb7" { ...commonProps } />,
  }

  useEffect(() => {
    updateContent()
  }, [] )

  return (
    <Routes>

      { pages.map( r => <Route key={ r.path } path={ r.path } element={ elements[ r.element ] } /> ) }

      <Route path="/login" element={<SignIn />} />
      <Route path="/admin" element={<Admin { ...adminProps } />} />
      <Route path="/cruises-update" element={<AdminCruises { ...adminProps } />} />
      <Route path="/pages-update" element={<AdminPages { ...adminProps } />} />
      <Route path="/bookings-update" element={<AdminBookings { ...adminProps } />} />

      {/* <Route path="/pages-order" element={<AdminPages order={ true } { ...adminProps } />} /> */}
      <Route path="*" element={ <Navigate replace to="/" /> } />
      
    </Routes>
  )
}

